import { IconButton, Link } from "@mui/material";
import { FaDiscord } from "react-icons/fa";
const Discord = () => {
  return <IconButton href='https://discord.gg/u5HDKzMe8z' LinkComponent={Link} target="_blank"><FaDiscord color="#fff"/></IconButton>;
}

export default Discord;